<template>
    <div class="pa-4">
        <div v-if="worklogLoading" class="d-flex justify-center">
            <v-progress-circular indeterminate size="32" width="2" color="primary lighten-2"></v-progress-circular>
        </div>
        <div v-else>
            <div v-if="worklog.length">
                <div class="d-flex text-center flex-wrap">
                    <div v-for="logItem in worklog" :key="logItem.holidayName" class="log-square">
                        <v-btn icon v-if="logItem.holidayName === 'Sickness Episodes'" @click="openSickDialog(logItem)">
                            <v-icon>mdi-cursor-default-click-outline</v-icon>
                        </v-btn>
                        <div class="caption">{{ logItem.holidayName }}</div>
                        <div><strong>{{ logItem.value }}</strong></div>
                    </div>
                </div>
            </div>
            <div v-else class="text-center py-1">No data available</div>
        </div>
        <SickDialog v-if="sickDialog" :sickDialog="sickDialog" :sickEmployee="sickEmployee" @closeDialog="sickDialog = false"/>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import { NAME_HOLIDAY_BY_KEY, TYPES_HOLIDAY } from '@/constatns/typesOfHolidays'
    import SickDialog from '@/views/accounting/SickDialog'

    export default {
        name: 'AppraisalWorkLog',
        components: { SickDialog },
        props: ['date', 'worklogLoading', 'userId', 'employeeName'],

        data () {
            return {
                worklog: [],
                sickDialog: false,
                sickEmployee: {},
                holidayKeys: [
                    TYPES_HOLIDAY.PAID_HOLIDAY,
                    TYPES_HOLIDAY.BANK_HOLIDAY,
                    TYPES_HOLIDAY.MATERNITY_APPOINTMENT,
                    TYPES_HOLIDAY.MATERNITY_LEAVE,
                    TYPES_HOLIDAY.COLLEGE_DAY,
                    TYPES_HOLIDAY.UNAUTHORIZED_ABSENCE,
                    TYPES_HOLIDAY.UNPAID_HOLIDAY,
                    TYPES_HOLIDAY.DEPENDENT_ABSENCE,
                    TYPES_HOLIDAY.OTHER_APPOINTMENT,
                    TYPES_HOLIDAY.EXTRA,
                    TYPES_HOLIDAY.CONTRACTED,
                    TYPES_HOLIDAY.LATES,
                    TYPES_HOLIDAY.AUTHORIZED_SICK,
                    TYPES_HOLIDAY.UNAUTHORIZED_SICK,
                    TYPES_HOLIDAY.SICKNESS_EPISODES
                ]
            }
        },

        methods: {
            ...mapActions(['getYearWorklog']),
            openSickDialog (data) {
                if (data.holidayName !== 'Sickness Episodes') return
                this.sickDialog = true
                this.sickEmployee = {
                    employeeId: this.userId,
                    name: this.employeeName,
                    date: this.date
                }
            },
            async getWorklog () {
                this.worklog = []
                try {
                    this.$emit('updateWorklogLoading', true)
                    const queryData = {
                        EmployeeId: this.userId,
                        Month: this.date
                    }
                    const worklogData = await this.getYearWorklog(queryData)
                    const localWorkLog = []
                    this.holidayKeys.forEach(holidayItem => {
                        const localNewItem = {
                            holidayName: NAME_HOLIDAY_BY_KEY[holidayItem]
                        }
                            Object.entries(worklogData.data.items[0]).forEach(keyValue => {
                                if (holidayItem.toLowerCase() === keyValue[0].toLowerCase()) {
                                    localNewItem.value = keyValue[1]
                                }
                            })
                        if (localNewItem.value > 0) localWorkLog.push(localNewItem)
                    })
                    this.worklog = localWorkLog
                    this.$emit('updateWorklogLoading', false)
                } catch (e) {
                    this.$emit('updateWorklogLoading', false)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .log-square {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 130px;
        height: 100px;
        border:1px solid white;
        background: #ccc;
        border-radius: 5px;
    }
</style>
